// helper: seconds → MM:SS
export const fmt = (s) => {
    if (s == null || Number.isNaN(s))
        return "";
    const m = Math.floor(s / 60);
    const ss = String(Math.floor(s % 60)).padStart(2, "0");
    return `${m}:${ss}`;
};
